import React, { memo } from 'react'
import AppointmentTimeRange from 'transfix-ui/components/AppointmentTag/components/AppointmentTimeRange'
import MapMarker from 'transfix-ui/components/MapMarker'
import Typography from 'transfix-ui/core/Typography'
import { IAddress, IMarketplaceStops } from 'types/FMSGraphqlTypes'
import { capitalize } from 'utils/capitalize'
import { getMapMarkerType } from '../../utils'

export interface IShipmentStopDetailsProps {
  stop: Pick<
    IMarketplaceStops,
    'stopType' | 'stopSequence' | 'startAt' | 'endAt' | 'displayTimezone'
  > & {
    address: Pick<IAddress, 'locality' | 'subdivisionCode'>
  }
  dataTest?: string
  /**
   * @default false
   */
  disabled?: boolean
}

const ShipmentStopDetails = memo<IShipmentStopDetailsProps>(
  ({ dataTest = '', disabled = false, stop }) => {
    const { address, displayTimezone: timezone, endAt, startAt, stopType } = stop || {}
    const { locality: city, subdivisionCode: stateCode } = address || {}

    const location = city ? `${capitalize(city)}, ${stateCode}` : stateCode

    const startAtHasTime = Boolean(startAt)
    const endAtHasTime = Boolean(endAt)

    const mapMarkerType = getMapMarkerType(stopType)

    const locationColor = disabled ? 'textSecondary' : 'initial'
    const markerStyle = disabled ? 'disabled' : 'traditional'

    return (
      <div className='stop'>
        <MapMarker mini type={mapMarkerType} markerStyle={markerStyle} />
        <div>
          <Typography
            variant='subtitle2'
            component='div'
            color={locationColor}
            data-test={`${dataTest}-location`}>
            {location}
          </Typography>
          {timezone && (
            <Typography
              variant='caption'
              color='textSecondary'
              component='div'
              data-test={`${dataTest}-time`}>
              <AppointmentTimeRange
                start={{ datetime: startAt, timezone, hasTime: startAtHasTime }}
                end={{ datetime: endAt, timezone, hasTime: endAtHasTime }}
              />
            </Typography>
          )}
        </div>
      </div>
    )
  }
)

export default ShipmentStopDetails
